document.addEventListener('DOMContentLoaded', function() {
    let productFieldset = document.querySelector('.product__info-wrapper product-info variant-radios  fieldset.js.product-form__input');
    let productRadios = productFieldset.querySelectorAll('input[type="radio"]');
    let newVariantWithEmptyType = null;
    let anyNewVariant = null;
    let saleVariants = [];

    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
  
    if (!variantId) {
        for (let radio of productRadios) {
            let label = document.querySelector(`label[for="${radio.id}"]`);
            let variantNamePrice = label.querySelector('.variant-name-price').textContent;
            let variantTypeName = label.querySelector('.variant-type-name').textContent.trim();
            let isDisabled = radio.classList.contains('disabled');

            let compareAtPrice = radio.getAttribute("data-compare-at-price");
            let priceValue = radio.getAttribute("data-price-value");

            if (compareAtPrice && !isDisabled) {
                let priceValueNumber = parseFloat(priceValue.replace(/[\$,]/g, ''));
                saleVariants.push({radio: radio, price: priceValueNumber});
            }

            if (variantNamePrice.includes('New') && !isDisabled)
                anyNewVariant = radio;
                if (!variantTypeName && !isDisabled) {
                    newVariantWithEmptyType = radio;
                    break;
                }
            }
        }

        saleVariants.sort((a, b) => a.price - b.price);
        if (saleVariants.length > 0) {
            saleVariants[0].radio.click();
        } else if (newVariantWithEmptyType) {
            newVariantWithEmptyType.click();
        } else if (anyNewVariant) {
            anyNewVariant.click();
        } else {
        for (let radio of productRadios) {
            if (radio.value == variantId) {
                radio.click();
                break;
            }
        }
    }
    const radioButtons = document.querySelectorAll('.product__info-wrapper variant-radios input[type="radio"]');
    radioButtons.forEach(function(radio) {
        radio.addEventListener('change', function(event) {
            updateProductTitle(event);
            updateProductDescription(event);
            updateProductFeatures(event);
            updateBlinkContainer(event);
        });
    });
    function updateProductTitle(event) {
        const nameMetafield = event.target.getAttribute('data-name-metafield');
        const productTitle = document.querySelector('.product__title h1');
        const productTag = document.querySelector('.product__title h2');
        const productBreadcrums = document.querySelector('section.breadcrumbs.page-width nav.breadcrumb span:nth-child(3)');
        const additionalAttributesProductName = document.querySelector('.additional-attributes-wrapper.table-wrapper table#product-attribute-specs-table td.col.data[data-th="Product Name"]');

        if (nameMetafield) {
            if (productTitle) {
                productTitle.textContent = nameMetafield;
            }
            if(productBreadcrums){
                productBreadcrums.textContent = nameMetafield;
            }
            if (productTag) {
                productTag.textContent = nameMetafield;
            }
            if (additionalAttributesProductName) {
                additionalAttributesProductName.textContent = nameMetafield;
            }
        }
    }
    function updateProductDescription(event) {
        const descriptionMetafield = event.target.getAttribute('data-metafield-description');
        const productDescription = document.querySelector('.product__description.rte');

        if (descriptionMetafield) {
            if (productDescription) {
                productDescription.innerHTML = descriptionMetafield;
            }
        }
    }
    function updateProductFeatures(event) {
        const featureMetafield = event.target.getAttribute('data-metafield-features');
        const productFeatures = document.querySelector('#tab-specs');

        if (featureMetafield) {
            if (productFeatures) {
                productFeatures.innerHTML = featureMetafield;
            }
        }
    }
    //New Function to display the Blink Popup
    function updateBlinkContainer(event) {
        let blinkRegion = event.target.getAttribute('data-blink-region');
        let blinkContainer = document.querySelector('.blink-container');
        if (blinkContainer) {
            if (blinkRegion === "0") {
                blinkContainer.style.display = 'none';
            } else {
                blinkContainer.style.display = 'block';
            }
        }
    }
    //Add Click Event to the Blink Image for the Popup
    setTimeout(() => {
        let blinkImages = document.querySelectorAll('.blink-container img');
        let blinkModal = document.querySelector('.blink-modal-inner-wrap');
        let body = document.body;
        blinkImages.forEach(blinkImage => {
            blinkImage.addEventListener('click', function() {
                if (blinkModal) {
                    blinkModal.style.display = 'block';
                    blinkModal.style.opacity = '1';
                    body.classList.add('blink-modal-opened');
                }
            });
        });
        let closeButton = blinkModal ? blinkModal.querySelector('.action-close') : null;
        if (closeButton) {
            closeButton.addEventListener('click', function() {
                blinkModal.style.display = 'none';
                blinkModal.style.opacity = '0';
                body.classList.remove('blink-modal-opened');
            });
        }
    }, 500);

});